// dependencies
import React, { useEffect, useState } from "react";

import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

// store
import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: string[];
	customFieldName: string;
	isMultiSelect?: boolean;
}

const FieldValuesPicker = (props: BaseProps) => {
	const { onChange, value = [], customFieldName, isMultiSelect } = props;
	const [fields, setFields] = useState<Result[]>([]);

	const [fetchSelectFieldOptions] = useQueryBuilderStore((state) => [state.fetchSelectFieldOptions]);

	const getFields = async () => {
		const fieldOptions = await fetchSelectFieldOptions(customFieldName);
		setFields(fieldOptions);
	};

	useEffect(() => {
		getFields();
	}, [customFieldName]);

	// needed for SelectInput to access labels for chips
	const valuesAsValueLabelObjects: Result[] = value.map((val) => ({
		value: val,
		label: fields.find((field) => field.value === val)?.label ?? "",
	}));

	return (
		<SelectInput
			isMultiSelect={isMultiSelect}
			results={fields}
			onChange={onChange}
			value={valuesAsValueLabelObjects}
		/>
	);
};

export default FieldValuesPicker;
